const internalBreakpoints = { xs: 320, sm: 480, md: 768, lg: 1024, xl: 1440 };

const mapValues = <A, B>(obj: A, f: (value: A[keyof A]) => B) => {
  return Object.assign(
    {},
    ...Object.keys(obj).map((key) => ({ [key]: f(obj[key as keyof A]) })),
  ) as { [k in keyof A]: B };
};

export const breakpoints = {
  up: mapValues(internalBreakpoints, (pixels) => `(min-width: ${pixels}px)`),
  down: mapValues(
    internalBreakpoints,
    (pixels) => `(max-width: ${pixels - 1}px)`,
  ),
};
